import { type DescMethod } from '@bufbuild/protobuf';
import { type ReactNode } from 'react';
import { useRpcPermissions } from '@/hooks/useRpcPermissions';
import { type NonEmptyArray } from '@/utils/types';

export function WithRpcPermissions<
  T extends NonEmptyArray<DescMethod>,
  TShow extends 'match' | 'always' = 'match',
>(props: {
  methods: T;
  render: TShow extends 'always' ? (props: { matches: boolean }) => ReactNode : () => ReactNode;
  show?: TShow;
  combinator?: T['length'] extends 1 ? 'allOf' : 'allOf' | 'anyOf';
}) {
  const { methods, render, show = 'match' as TShow, combinator = 'allOf' } = props;

  const { matches } = useRpcPermissions(methods, combinator);

  if (show === 'always') {
    return render({ matches });
  }

  return matches ? render(undefined as never) : null;
}
